<template>
  <div class="">

      <div class="modal fade" id="modal-send-quote" data-backdrop="static" focus="true" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                  Send Quote
              </h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
                <div class="row" v-if="!success">
                    <div class="mb-3">
                        <label for="email" class="form-label">Email</label>
                        <input type="text" class="form-control" id="email" v-model="quote_params.email" :readonly="sending">
                        <div id="emailHelp" class="form-text">This feature is still in beta. Please email yourself and verify that the quote document is accuarate before sending it to the customer.</div>
                    </div>

                    <div class="mb-3">
                        <label for="title" class="form-label">Subject</label>
                        <input type="text" class="form-control" id="title" v-model="quote_params.title" :readonly="sending">
                     </div>
                     <div class="mb-3">
                        <label for="body" class="form-label">Body</label>
                        <textarea class="form-control" id="body" rows="2" v-model="quote_params.body" :readonly="sending"></textarea>
                     </div>
                     <div class="mb-3">
                        <label for="notes" class="form-label">Notes</label>
                        <input class="form-control" id="notes" v-model="quote_params.notes" :readonly="sending">
                        <div id="notesHelp" class="form-text">Note will be added to the ADDITIONAL NOTES section of the quote PDF. This can be left blank.</div>
                     </div>
                     
                  
             
                    

                </div>
                <div class="row">
                    <div class="mb-1 alert alert-success text-center" role="alert" v-if="success">
                        {{ result }}
                    </div>
                     <div class="mb-1 alert alert-danger text-center" role="alert" v-if="errors.length > 0">
                        {{ errors }}
                    </div>
                </div>
            </div>
            <!-- Modal Actions -->
            <div class="modal-footer border-none">
                <button type="button" class="btn btn-light" @click="closeModal">
                    Close
                </button>
                <span v-if="!success">
                    <button v-if="!sending" type="button" class="btn btn-light text-white" style="background-color:#ff7a59;"  @click="emailQuote">Send Quote</button>
                    <button v-else type="button" class="btn btn-light text-white" style="background-color:#ff7a59;" disabled><i class="fa fa-spinner fa-spin"></i>&nbsp; Sending...</button>
                </span>
              
            </div>
          </div>
        </div>
      </div>

      <!-- end of modal -->
  </div>
</template>

<style lang="css">

</style>

<script>
  import moment from 'moment'
  export default {
    // props:['order'],
    props:{
        // onSaveCallback: {
        //     type: Function,
        //     default: function () {return true;}
        // },
        orderId: {
            type: Number,
            required: true,
        },
        email: {
            type: String,
            default: null,
            required: false,
        },
        paymentTerms: {
            type: String,
            required: false,
        },
    },
    data() {
      return {
        errors: [],
        result: null,
        showing_modal: false,
        updating: false,
        sending: false,
        success: false,
        quote_params: {
            'id': 0,
            'email': null,
            'title': 'Doomswell Order Quote',
            'body': 'Your new quote is attached.',
            'notes': '',
            'paymentTerms': ''
        },
      };
    },
    created() {
      // runs when the component is created
      // this.alias();
      Bus.$on('sendQuoteModalShow', () => {
        this.quote_params.id = structuredClone(this.orderId);
        this.quote_params.email = structuredClone(this.email);
        this.quote_params.paymentTerms = structuredClone(this.paymentTerms);
        this.showModal();
        // this.test();
      });
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {
    },
    methods: {
      closeModal(){
        $('#modal-send-quote').modal('hide');
        Bus.$emit('updateOrderItems');
        this.showing_modal = false;
      },
      showModal(){
        $('#modal-send-quote').modal('show');
        this.showing_modal = true;
      },
      emailQuote(){
        this.sending = true;
        let params = this.quote_params;
        axios.get('/send-pdf', {
                params: params,
            }).then((res)=>{
                this.result = res.data.data;
                this.success = true;
                this.sending = false;
                
            // this.successfulSave();
            // this.updating = false;
            // this.closeModal();
            // this.saved = true;
            // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
        }).catch((error) => {
          console.log(error);
          this.errors.push({msg: error.response.data.message });
          // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
        });
    },
      successfulSave(){
        this.onSaveCallback();
      },
      
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
    },
    watch:{
      
    }
  }
  // Bus.$emit('updateUser');
</script>